import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import chatService from "../../firebase/chatService";

// إنشاء محادثة جديدة
export const createFirebaseConversation = createAsyncThunk(
    "firebaseChat/createConversation",
    async ({ senderId, receiverId }, { rejectWithValue }) => {
        try {
            const conversationId = await chatService.createConversation(senderId, receiverId);
            return { conversationId, senderId, receiverId };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// إرسال رسالة
export const sendFirebaseMessage = createAsyncThunk(
    "firebaseChat/sendMessage",
    async ({ conversationId, senderId, message }, { rejectWithValue }) => {
        try {
            const messageId = await chatService.sendMessage(conversationId, senderId, message);
            return { messageId, conversationId, senderId, message };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// جلب محادثة
export const getFirebaseConversation = createAsyncThunk(
    "firebaseChat/getConversation",
    async ({ senderId, receiverId }, { rejectWithValue }) => {
        try {
            const conversation = await chatService.getConversation(senderId, receiverId);
            return conversation;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const firebaseChatSlice = createSlice({
    name: "firebaseChat",
    initialState: {
        currentConversation: null,
        messages: [],
        conversations: [],
        loading: false,
        error: null,
        isListening: false
    },
    reducers: {
        setCurrentConversation: (state, action) => {
            state.currentConversation = action.payload;
        },
        setMessages: (state, action) => {
            state.messages = action.payload;
        },
        addMessage: (state, action) => {
            state.messages.push(action.payload);
        },
        clearMessages: (state) => {
            state.messages = [];
        },
        setListening: (state, action) => {
            state.isListening = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
        resetFirebaseChat: (state) => {
            state.currentConversation = null;
            state.messages = [];
            state.conversations = [];
            state.loading = false;
            state.error = null;
            state.isListening = false;
        }
    },
    extraReducers: (builder) => {
        // Create Conversation
        builder
            .addCase(createFirebaseConversation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createFirebaseConversation.fulfilled, (state, action) => {
                state.loading = false;
                state.currentConversation = {
                    id: action.payload.conversationId,
                    senderId: action.payload.senderId,
                    receiverId: action.payload.receiverId
                };
            })
            .addCase(createFirebaseConversation.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        // Send Message
        builder
            .addCase(sendFirebaseMessage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendFirebaseMessage.fulfilled, (state, action) => {
                state.loading = false;
                // الرسالة ستضاف تلقائياً من Firebase listener
            })
            .addCase(sendFirebaseMessage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        // Get Conversation
        builder
            .addCase(getFirebaseConversation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getFirebaseConversation.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    state.currentConversation = action.payload;
                }
            })
            .addCase(getFirebaseConversation.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { 
    setCurrentConversation, 
    setMessages, 
    addMessage, 
    clearMessages,
    setListening,
    clearError,
    resetFirebaseChat
} = firebaseChatSlice.actions;

export default firebaseChatSlice.reducer;
